export type EvcButtonType = 
      'primary'
      | 'secondary'
      | 'tertiary'
      | 'cta'
      | 'link'
      | 'error-primary'
      | 'icon'
      | 'error-secondary'
      | 'error-tertiary';

export type EvcButtonSize = 'lg' | 'sm' | 'xs' | 'xxl';
export type EvcButtonVariant = 'round' | 'square' | 'semi';

export const EvcButtonType = {
  primary: 'primary' as EvcButtonType,
  secondary: 'secondary' as EvcButtonType,
  tertiary: 'tertiary' as EvcButtonType,
  cta: 'cta' as EvcButtonType,
  link: 'link' as EvcButtonType,
  errorPrimary: 'error-primary' as EvcButtonType,
  icon: 'icon' as EvcButtonType,
  errorSecondary: 'error-secondary' as EvcButtonType,
  errorTertiary: 'error-tertiary' as EvcButtonType,
};

export const EvcButtonSize = {
  lg: 'lg' as EvcButtonSize,
  sm: 'sm' as EvcButtonSize,
  xs: 'xs' as EvcButtonSize,
  xxl: 'xxl' as EvcButtonSize
};

export const EvcButtonVariant = {
  round: 'round' as EvcButtonVariant,
  square: 'square' as EvcButtonVariant,
  semi: 'semi' as EvcButtonVariant,
};